export {
    isArray,
    isString,
    isFunction,
    isObject,
    isDate,
    isPromise,
    isSymbol,
} from '@vue/shared'

export {
    isBoolean,
    isNumber,
} from '@vueuse/core'

export {
    isVNode
} from 'vue'

export const isUndefined = (val: any): val is undefined => val === undefined

export const isRegExp = (val: any): val is RegExp => {
    return  Object.prototype.toString.call(val) === 'RegExp'
}
